module.exports = __webpack_public_path__ + "static/media/5.d618b09e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/minsk/5.jpg
// module id = 231
// module chunks = 0